function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Box } from "sprout-ui-primitives";
import { MenuTitle } from "@sprout/list-navigation/dist/Menu";
import { themeGet } from "sprout-ui-theme";
import AppHelpMenuKeyboardShortcut from "./AppHelpMenuKeyboardShortcut";
const StyledBox = styled(Box)`
  > div + div {
    border-top: 1px solid ${themeGet("colors.blue.500")};
  }
`;
const AppHelpMenuKeyboardShortcutsGroup = (props)=>{
    const { shortcuts , groupTitle  } = props;
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(MenuTitle, {
                mx: null,
                mb: 3,
                children: groupTitle
            }),
            /*#__PURE__*/ _jsx(StyledBox, {
                borderRadius: "15px",
                bg: "white.12",
                children: shortcuts.map((action)=>{
                    return /*#__PURE__*/ _jsx(AppHelpMenuKeyboardShortcut, _objectSpread({}, action), action.label);
                })
            })
        ]
    });
};
export default AppHelpMenuKeyboardShortcutsGroup;
